import React, { useState, useCallback } from 'react';
import clsx from 'clsx';
import { Image, T, Tooltip } from '@colonist/ui';
import { clamp } from '@colonist/utils';
import IconDanger from '@static/images/icon_danger_red.svg';
import styles from './TextValidationWrapper.module.scss';
/** Renders a child input/textarea with optional max length + counter, and optional error message. */ export const TextValidationWrapper = ({ maxLength, errorMessage, children })=>{
    const clampedMaxLength = maxLength != undefined ? clamp(maxLength, 0, Number.POSITIVE_INFINITY) : undefined;
    const [charCount, setCharCount] = useState(0);
    const hasErrorMessage = errorMessage != undefined;
    const showCharacterCount = clampedMaxLength != undefined;
    const showFooter = hasErrorMessage || showCharacterCount;
    const fieldRef = useCallback((node)=>{
        if (node != undefined) setCharCount(node.value.length);
    }, []);
    const handleChange = (e)=>{
        setCharCount(e.target.value.length);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.wrapper
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.fieldContainer, hasErrorMessage && styles.hasError)
    }, children({
        maxLength: clampedMaxLength,
        onChange: handleChange,
        ref: fieldRef
    }), hasErrorMessage && /*#__PURE__*/ React.createElement(Tooltip, {
        position: "top-end",
        content: /*#__PURE__*/ React.createElement(T, {
            id: errorMessage
        }),
        className: styles.dangerIcon
    }, /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: IconDanger,
            alt: 'strings:imgAlts.DangerIcon'
        }
    }))), showFooter && /*#__PURE__*/ React.createElement("div", {
        className: styles.footer
    }, hasErrorMessage && /*#__PURE__*/ React.createElement("span", {
        className: styles.errorMessage,
        "data-testid": "text-validation-error"
    }, /*#__PURE__*/ React.createElement(T, {
        id: errorMessage
    })), showCharacterCount && /*#__PURE__*/ React.createElement("span", {
        className: styles.characterCount
    }, charCount, "/", clampedMaxLength)));
};
